module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Map/Direction1-0cddace6a223d282c32e551ac743572d.svg";